import requestFunctions from "../../functions/requestFunctions";


export const state = {
  BOTS_SKILLS_ITEM: {},
  BOTS_SKILLS_LIST: [],
  BOTS_SKILLS_TABLE_DATA: [],
  BOTS_SKILLS_LIST_DATA: [],
  BOTS_SKILLS_TOTAL_ROWS: 0
}

export const getters = {
  GET_BOTS_SKILLS_ITEM: (state) => {
    return state.BOTS_SKILLS_ITEM;
  },
  GET_BOTS_SKILLS_LIST: (state) => {
    return state.BOTS_SKILLS_LIST;
  },
  GET_BOTS_SKILLS_TABLE_DATA: (state) => {
    return state.BOTS_SKILLS_TABLE_DATA;
  },
  GET_BOTS_SKILLS_LIST_DATA: (state) => {
    return state.BOTS_SKILLS_LIST_DATA;
  },
  GET_BOTS_SKILLS_TOTAL_ROWS: (state) => {
    return state.BOTS_SKILLS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_BOTS_SKILLS_ITEM(state, item) {
    state.BOTS_SKILLS_ITEM = item;
  },

  UPDATE_BOTS_SKILLS_LIST(state, list) {
    
    state.BOTS_SKILLS_LIST = list.data;

    state.BOTS_SKILLS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.BOTS_SKILLS_TABLE_DATA = [];
    state.BOTS_SKILLS_LIST_DATA = [];

    list.forEach(el => {

      state.BOTS_SKILLS_TABLE_DATA.push({
        'uuid' : el.uuid
      });

      state.BOTS_SKILLS_LIST_DATA.push({
        id: el.id,
        uuid: el.uuid,
      });
      
    });
  },
}

export const actions = {

  async FETCH_BOTS_SKILLS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/skills/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_BOTS_SKILLS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_BOTS_SKILLS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/skills';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_BOTS_SKILLS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_BOTS_SKILLS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/skills';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_BOTS_SKILLS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/skills/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_BOTS_SKILLS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/skills/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}